import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs/internal/Observable';
import {
  Country,
  GetAutopayStatusResponse,
  EnableAutopayV1Request,
  DisableAutopayV1Request,
  GetBankHolidayScheduleResponseV1,
  AutopayEligibilityResponse,
} from '../models';

export abstract class PaymentSchedulerService {
  protected baseUrl: string;

  constructor(protected appConfig: AppConfigSettings) {
    this.baseUrl = this.appConfig.getconfig('paymentSchedulerServiceUrl');
  }

  abstract getBankHolidayScheduleV1(
    tenantId: string,
    country: Country,
  ): Observable<GetBankHolidayScheduleResponseV1>;

  abstract getCutoffTimeScheduleV1(
    tenantId: string,
    version: string,
  ): Observable<string>;

  abstract getAutopayStatusV1(
    tenantId: string,
    accountNumber: string,
  ): Observable<GetAutopayStatusResponse>;

  abstract enableAutopayV1(
    tenantId: string,
    accountNumber: string,
    request: EnableAutopayV1Request,
  ): Observable<void>;

  abstract disableAutopayV1(
    tenantId: string,
    accountNumber: string,
    request: DisableAutopayV1Request,
  ): Observable<void>;

  abstract getAutopayEligibilityV1(
    tenantId: string,
    accountNumber: string,
  ): Observable<AutopayEligibilityResponse>;
}
